module.exports = __webpack_public_path__ + "h5/img/red_icon.cbb02566.png";